import Joi from 'joi';

export const MoveLicenseToIsacaValidator = {
  schema: Joi.object()
    .keys({
      licensedOrgUnitId: Joi.number().required()
    })
    .unknown(true)
};
